export const GET_POLL_AND_SURVEY_DETAILS = "GET_POLL_AND_SURVEY_DETAILS";
export const RESET_DATA = "RESET_DATA";
export const START_LOADING_POLL_AND_SURVEY_DETAILS = "START_LOADING_POLL_AND_SURVEY_DETAILS";
export const STOP_LOADING_POLL_AND_SURVEY_DETAILS = "STOP_LOADING_POLL_AND_SURVEY_DETAILS";
export const ERROR_LOADING_POLL_AND_SURVEY_DETAILS = "ERROR_LOADING_POLL_AND_SURVEY_DETAILS";